// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".-tkyi{display:flex;align-items:center;justify-content:center}.-tkyi path{color:#e2e2e2;transition:color .3s}.-tkyi._3du-n path:first-child,.-tkyi.O7UG5 path:nth-child(2){color:#2d2d2d}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": "-tkyi",
	"ascending": "_3du-n",
	"descending": "O7UG5"
};
module.exports = ___CSS_LOADER_EXPORT___;
